/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_StaleInputs */

const id_reseller_pricing_stale = /** @type {(inputs: Reseller_Pricing_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran KilatDomain untuk TLD ini berubah. Muat ulang halaman.`)
};

const en_reseller_pricing_stale = /** @type {(inputs: Reseller_Pricing_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KilatDomain's offer for this TLD has changed. Reload the page.`)
};

/**
* | output |
* | --- |
* | "KilatDomain's offer for this TLD has changed. Reload the page." |
*
* @param {Reseller_Pricing_StaleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_stale = /** @type {((inputs?: Reseller_Pricing_StaleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_StaleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_stale(inputs)
	return id_reseller_pricing_stale(inputs)
});